// src/pages/RiwayatPresensi.js
import React, { useEffect, useState, useRef, useCallback } from "react";  
import { fetchRiwayatJurnal } from "../services/riwayatService";
import BottomNavbar from "../components/BottomNavbar";

function RiwayatPresensi() {
  const [riwayat, setRiwayat] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const siswaId = localStorage.getItem("user_id");

  const fetchedPages = useRef(new Set());
  const firstLoadDone = useRef(false);

  const loadData = useCallback(
    async (currentPage) => {
      if (!siswaId || fetchedPages.current.has(currentPage)) return;
      setLoading(true);

      const result = await fetchRiwayatJurnal(siswaId, currentPage);

      if (result.success) {
        const newData = result.data.data;
        setRiwayat((prev) => [...prev, ...newData]);

        fetchedPages.current.add(currentPage);

        const { current_page, last_page } = result.data;
        setHasMore(current_page < last_page);
      }

      setLoading(false);
    },
    [siswaId]
  );

  useEffect(() => {
    if (!firstLoadDone.current) {
      firstLoadDone.current = true;
      loadData(page);
    }
  }, [page, loadData]);

  const handleLoadMore = () => {
    if (!loading && hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  return (
    <div style={{ minHeight: "100vh", paddingBottom: "80px" }}>
      <h5 className="text-center mt-4 fw-bold">Riwayat Presensi</h5>

      <div className="container mt-3">
        {riwayat.length === 0 && !loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "50vh" }}
          >
            <p className="text-muted mb-0">Belum ada riwayat.</p>
          </div>
        ) : (
          riwayat.map((item, index) => {
            const tanggal = item.created_at?.split("T")[0];
            const masuk = item.jam_check_in || "-";
            const keluar = item.jam_check_out || "-";
            const izinLabel = item.jenis_izin === "sakit" ? "Sakit (S)" : "Izin (I)";
            const status =
              item.status === "izin" || item.status === "menunggu"
                ? izinLabel
                : item.keterangan_check_in || item.status;

            return (
              <div
                key={item.id || `${item.created_at}-${index}`}
                className="mb-3 p-3"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                }}
              >
                <h6 className="fw-bold mb-3">{tanggal}</h6>
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-box-arrow-in-right text-success me-2"></i>
                  <span className="me-2">Masuk:</span>
                  <strong>{masuk}</strong>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-box-arrow-left text-danger me-2"></i>
                  <span className="me-2">Keluar:</span>
                  <strong>{keluar}</strong>
                </div>
                <div>
                  {item.keterangan_check_in === null ? (
                    <span className="badge bg-warning text-dark">{status}</span>
                  ) : (
                    <span className="badge bg-light text-muted">{item.keterangan_check_in}</span>
                  )}
                </div>
              </div>
            );
          })
        )}

        {loading && (
          <div className="text-center mt-3">
            <div className="spinner-border text-primary" role="status" />
          </div>
        )}

        {!loading && hasMore && riwayat.length > 0 && (
          <div className="text-center mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={handleLoadMore}
            >
              Tampilkan Lebih Banyak
            </button>
          </div>
        )}
      </div>

      <BottomNavbar />
    </div>
  );
}

export default RiwayatPresensi;
